export const portentaSpecs = [
  { label: "Form Factor", value: "Mid-Carrier · 114 × 102 mm" },
  { label: "Compatibility", value: "Arduino Portenta H7 / X8" },
  { label: "Connectivity", value: "Ethernet · Mini-PCIe · USB-A/C" },
  { label: "I/O", value: "MikroBUS · Camera CSI · CAN-FD" },
  { label: "Power", value: "5V – 36V wide range, 4A peak" },
  { label: "Operating Temp", value: "−40°C to +85°C industrial" },
];

export const callouts = [
  {
    number: "01",
    title: "High-Density Connectors",
    body: "Two 80-pin board-to-board stack offers 240 GPIO and high-speed differential pairs to the Portenta module.",
  },
  {
    number: "02",
    title: "MikroBUS Expansion",
    body: "Two MikroBUS slots accept 1000+ Click boards — sensors, modems, radios — without custom firmware.",
  },
  {
    number: "03",
    title: "Industrial I/O",
    body: "Isolated CAN-FD, RS-485 and Ethernet PHY designed for harsh factory and mobile robotics environments.",
  },
  {
    number: "04",
    title: "Wide Power Input",
    body: "5–36V DC input with reverse-polarity protection and selectable 3.3V/5V rails for accessories.",
  },
];